import { useRouter } from "next/router";
import { NavProvider } from "@context/NavContext";
import NavBar from "./NavBar";

/**
 * Layout component
 * @param {Object} props - The component props
 * @param {"white"} props.variant - Layout variant, determines the background color
 * @param {string} props.padding - Layout padding
 * @param {ReactNode} props.children - Layout children
 * @returns {ReactNode} Layout component
 */
const Layout = ({ children, variant, padding }) => {
  const router = useRouter();

  return (
    <NavProvider>
      <div
        className={`w-dvw h-dvh flex gap-2 ${
          variant == "white" ? "bg-white" : "bg-grey-background"
        }`}
      >
        <NavBar />
        <div
          className={`grow h-full overflow-y-auto ${
            variant == "white" ? "border-l" : ""
          } ${padding ?? "p-8"}`}
        >
          {children}
        </div>
      </div>
    </NavProvider>
  );
};

export default Layout;
